import IconFont from "@/components/icon";
import { Avatar, Empty, List, message, Tooltip, Tree } from "antd";
import React, { ReactNode, useContext, useMemo, useState, useCallback, useEffect } from "react";
import { DataListProps, ListItem, StateActionNames, Folder } from "./types";
import "./index.less";
import { useTranslation } from "@/components/Joyspace/context";
import InfiniteScroll from "react-infinite-scroller";
import { StoreContext } from "./store";
import { changeEgovUrl } from "@/utils/tools";
import { PermissionEnum } from "@/components/Joyspace/const";
import { includes } from "lodash";
import { getHighlightComp } from "@/utils/search";
import Loading from "@/components/Loading";
import noData from "@/assets/img/offline-noData.png";
const { DirectoryTree } = Tree;

export default function DataList(props: DataListProps) {
  const [state, dispatch] = useContext(StoreContext);
  const [treeData, setTreeData] = useState([]);
  const [selectedKeys, setSelectedKeys] = useState([]);
  const t = useTranslation();
  const {
    title = "",
    onBack,
    onFolderClick,
    loadMore,
    loading,
    items,
    hasMore,
    currentFolder = {},
    searchValue = ""
  } = props;
  const Icon = (item: any) => {
    return <img style={{ width: "20px" }} src={changeEgovUrl(item.iconUrl)} />;
  };
  const hanldeData = useCallback(
    (list: any) => {
      return list.map((item: any) => {
        item.key = item.id;
        item.checkable = item.type === "page";
        item.disableCheckbox = item.type === "folder";
        item.icon = <Icon {...item} />;
        item.isLeaf = item.type === "page";
        item.children = [];
        // item.selectable = state.selectedItems.some(
        //   (si: ListItem) => si.type === item.type && si.id === item.id
        // );
        item.selectable = false;
        if (item.type === "page") {
          if (state.controlMethod) {
            item.disabled = state.controlMethod(item);
          } else {
            item.disabled = item.status
              ? !item.permissions.includes(PermissionEnum.SHARE_CREATE)
              : true;
          }
        }
        item.name = item.title;
        item.title = (
          <Tooltip title={item.title} placement="right" autoAdjustOverflow>
            {item.title}
          </Tooltip>
        );

        return item;
      });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );
  const setHighlight = (item: any) => {
    if (!item.highlight) {
      return item;
    }
    item.title = (
      <Tooltip title={item.name} placement="right" autoAdjustOverflow>
        <span className="selector-highlight">
          {getHighlightComp(item.highlight, "title", item.title)}
        </span>
      </Tooltip>
    );
    return item;
  };
  const updateTreeData: any = useCallback((list: any[], key: any, children: any[]) => {
    if (!key || key === "myspace" || key === "teamRoot" || key === "groupspace") {
      return children.map((item) => {
        return setHighlight(item);
      });
    }
    return list.map((node) => {
      if (node.key === key) {
        return {
          ...node,
          children
        };
      }
      if (node.children) {
        return {
          ...node,
          children: updateTreeData(node.children, key, children)
        };
      }
      return node;
    });
  }, []);
  // const loop = (data: any) =>
  //     data.map((item: any) => {
  //         const index = item.title.indexOf(searchValue);
  //         const beforeStr = item.title.substr(0, index);
  //         const afterStr = item.title.substr(index + searchValue.length);
  //         console.log(index, 'indexindexindex');
  //         const title =
  //             index > -1 ? (
  //                 <span>
  //                     {beforeStr}
  //                     <span style={{ color: 'red' }}>{searchValue}</span>
  //                     {afterStr}
  //                 </span>
  //             ) : (
  //                 <span>{item.title}</span>
  //             );
  //         if (item.children) {
  //             return { title, key: item.key, children: loop(item.children) };
  //         }

  //         return {
  //             title,
  //             key: item.key,
  //         };
  //     });
  useMemo(() => {
    const folderId = currentFolder ? currentFolder.id : "";
    const _list: any = updateTreeData([...treeData], folderId, hanldeData([...items]));
    setTreeData(_list);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [items]);
  useMemo(() => {
    const ids = state.selectedItems.map((item: any) => {
      return item.id;
    });
    setSelectedKeys(ids);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.selectedItems, items]);
  const onLoadData = async (item: any) => {
    // console.log(item, 'itemitemitemitemitem');
    if (item.type === "folder") {
      await onFolderClick?.(item);
    } else if (item.type === "page") {
      dispatch({
        action: StateActionNames.TOGGLE_SELECTED,
        item: item
      });
    }

    return Promise.resolve();
  };
  return (
    <div
      className={`selector-data-list ${
        title === t("home.tabs.recent") ? "selector-recent-list" : ""
      }`}
    >
      <div
        className={`selector-data-list-body ${
          title === t("home.tabs.recent") ? "selector-recent-list-body" : ""
        }`}
      >
        {loading && (
          <div
            style={{
              width: "100%",
              height: "100%",
              display: "flex",
              flexDirection: "column"
            }}
          >
            <Loading />
          </div>
        )}
        {!loading && treeData.length === 0 && (
          <Empty image={noData} description="暂无数据" style={{ marginTop: "2vh" }} />
        )}
        {!loading && treeData.length !== 0 && (
          <DirectoryTree
            multiple
            showIcon
            checkable
            loadData={onLoadData}
            checkedKeys={selectedKeys}
            treeData={treeData}
            onCheck={(key: any, checkedNodes: any) => {
              const item = checkedNodes.node || {};
              if (item.type === "page") {
                const action = checkedNodes.checked
                  ? StateActionNames.TOGGLE_SELECTED
                  : StateActionNames.DELETE_SELECTED;
                item.title = item.name ? item.name : item.title;
                dispatch({
                  action,
                  item: item
                });
              }
            }}
          />
        )}

        {/* <InfiniteScroll
                    initialLoad={false}
                    pageStart={0}
                    loadMore={() => loadMore?.()}
                    hasMore={hasMore && !loading}
                    useWindow={false}
                >
                    <List
                        loading={loading}
                        dataSource={items}
                        split={false}
                        locale={{
                            emptyText: (
                                <Empty
                                    image={Empty.PRESENTED_IMAGE_SIMPLE}
                                    description={t('no data')}
                                />
                            ),
                        }}
                        renderItem={(item) => (
                            <List.Item
                                key={item.id}
                                className="selector-data-list-item"
                                onClick={() => {
                                    if (item.type === 'folder') {
                                        onFolderClick?.(item);
                                    } else if (item.type === 'page') {
                                        dispatch({
                                            action: StateActionNames.TOGGLE_SELECTED,
                                            item: item,
                                        });
                                    }
                                }}
                                actions={
                                    item.type === 'folder'
                                        ? [
                                              <IconFont
                                                  key="action-enter"
                                                  type="iconapp_ic_arrow_right"
                                              />,
                                          ]
                                        : undefined
                                }
                            >
                                {state.selectedItems.find(
                                    (si: ListItem) => si.type === item.type && si.id === item.id
                                ) ? (
                                    <IconFont
                                        key="action-selected"
                                        className="iconapp_btn_radio_selected"
                                        type="iconjs_ic_radio1"
                                        onClick={() => {}}
                                    />
                                ) : (
                                    <IconFont
                                        className="iconapp_btn_radio_normal"
                                        key="action-normal"
                                        type="iconbtn_checkbox"
                                        onClick={() => {}}
                                    />
                                )}
                                <List.Item.Meta
                                    avatar={
                                        <Avatar
                                            size={40}
                                            shape="square"
                                            src={changeEgovUrl(item.iconUrl)}
                                            className="joyspace-file-selector-avatar"
                                        />
                                    }
                                    title={
                                        <span
                                            dangerouslySetInnerHTML={{
                                                __html: item.title || t('untitled'),
                                            }}
                                        />
                                    }
                                />
                            </List.Item>
                        )}
                    />
                </InfiniteScroll> */}
      </div>
    </div>
  );
}
